import { P2GGrid } from '@parcel2go/core-ui';
import { ProductItem } from '~/components/core/product/adapters/product-types';
import { DuplicateItem } from './header/duplicate-item';
import { DeleteItem } from './header/delete-item';
import { EditParcelButton } from './header/edit-parcel-button';

export const BasketSummaryHeaderPrefix = ({
  index,
  name,
  productItem,
  onEdit,
  onRemove,
  onDuplicate,
  setOpenSwitcher,
  isXs
}: {
  index: number;
  name: string;
  productItem: ProductItem;
  onEdit: (id: string, action: string) => void;
  onRemove: (id: string) => void;
  onDuplicate: (id: string) => void;
  setOpenSwitcher: (open: boolean) => void;
  isXs?: boolean;
}) => {
  const options = [
    'SwitchService',
    'Origin',
    'Parcels',
    productItem.service.isDropOffService ? 'DropLocations' : 'CollectionDate',
    productItem.service.isShopDelivery ? 'DestinationPickUpLocations' : undefined
  ].filter(Boolean) as string[];

  if (isXs) {
    return (
      <>
        <P2GGrid item flexGrow={1} display="flex" justifyContent="flex-end">
          <DuplicateItem index={index} name={name} onDuplicate={onDuplicate} size="sm" />
        </P2GGrid>
        <P2GGrid item flexShrink={1} display="flex" justifyContent="flex-end">
          <DeleteItem index={index} name={name} onRemove={onRemove} size="sm" />
        </P2GGrid>
      </>
    );
  }

  return (
    <P2GGrid item>
      <EditParcelButton
        options={options}
        index={index}
        name={name}
        onEdit={onEdit}
        onRemove={onRemove}
        onDuplicate={onDuplicate}
        setOpenSwitcher={setOpenSwitcher}
        fullWidth={isXs}
      />
    </P2GGrid>
  );
};
